<template>
  <div :class="['widget-container', {'header-widget': header}]" v-loading="loading" >
    <div
       :class="['widget', {'widget-default-style': options.mode === 'basic'}]"
       :style="options.mode === 'advanced' ? options.style : null" >
      <div
         v-if="options.mode === 'basic'"
         :style="{'border-top-color': options.basic ? (options.basic.color || '#2f4050') : '#2f4050'}"
         class="border-top" />
      <transition
         leave-active-class="animated fadeOutUp"
         enter-active-class="animated fadeInDown" >
        <div
           v-show="showTitle || showMenu"
           class="widget-header"
           :style="options.headerStyle"
           @mouseover="preventTitleHide"
           @mouseout="hideTitle" >
          <div class="widget-header-title" v-if="title">
            <h2 v-if="title" >{{ title }}</h2>
          </div>
          <div class="widget-header-no-title" v-else></div>
          <div v-if="data.description || data.date" class="widget-header-menu" >
            <el-popover
               placement="left"
               trigger="hover" >
              <div>
                <div v-if="data.description" >{{ data.description }}</div>
                <div v-if="data.date" >
                  Date de référence des données:
                  {{ formatDate(data.date) }}
                </div>
              </div>
              <i slot="reference" class="handle el-icon-question" />
            </el-popover>
          </div>
          <div v-show="menu.length" class="widget-header-menu" @click="handleClick" >
            <el-cascader
               ref="menu"
               :options="menu"
               expand-trigger="hover"
               :show-all-levels="false"
               popper-class="widget-menu-cascader"
               @change="selectMenuItem" >
            </el-cascader>
            <i class="handle el-icon-fa-ellipsis-v" ></i>
          </div><!-- widget-header-menu -->
        </div><!-- widget-header -->
      </transition>
      <div class="widget-content" ref="content" >
        <div>
          <component
             v-if="refresh"
             :is="widget.widget"
             :options="widget.options"
             :widget="widget"
             @titleChange="handleTitleChange"
             @menuChange="handleMenuChange"
             @updateGraphData="handleUpdateGraphData" >
          </component>
        </div>
      </div>
      <div
         v-if="!options.showTitle && !showTitle"
         class="toggle-title"
         @mouseover="preventTitleHide"
         @mouseout="hideTitle" >
      </div>
    </div><!-- widget -->
    <draggable-box
       v-if="showStyleBox"
       title="Style du Widget"
       :width="360"
       :discardable="true"
       :collapsable="false"
       @discard="showStyleBox = false" >
      <style-box v-model="options" :widget="widget.id" ></style-box>
    </draggable-box>
    <draggable-box
       v-if="showDescriptionBox"
       title="Description du Widget"
       :width="360"
       :discardable="true"
       :collapsable="false"
       @discard="showDescriptionBox = false" >
      <el-form :model="data" >
        <el-form-item label="Description" >
          <el-input type="textarea" v-model="data.description" />
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="handleDescriptionCancel" >Annuler</el-button>
          <el-button type="success" @click="handleDescriptionSave" >Valider</el-button>
        </el-form-item>
      </el-form>
    </draggable-box>
  </div><!-- widget-container -->
</template>

<style lang="scss" scoped>
@import "./../style/colors.scss";
.widget-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
}
.widget-container.header-widget {
    position: relative;
}
.header-widget .widget-content {
    overflow: visible !important;
}
.header-widget >>> .vb-content {
    overflow: visible !important;
}
.widget {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    margin: 10px;
    background: #fff;
    border-radius: 15px;
    overflow: hidden;
    border: 1px solid #facbc0;
}
.header-widget .widget {
    position: relative;
}
.widget-default-style {
    border: 1px solid #facbc0;
}
.widget-default-style .border-top {
    position: absolute;
    border-top: 6px solid #5a5b5e;
    top: -6px;
    left: -1px;
    right: -1px;
}
.widget-header {
    display: flex;
    padding: 5px;
    padding-left: 0 !important;
    min-height: 35px;
    z-index: 5;
    border-bottom: 3px solid #ed6966;
    text-align: left;
    font-size: 11px;
}
.header-widget .widget-header {
    z-index: 0;
}
.widget-header-no-title {
    flex: 1;
    margin-right: 10%;
}
.widget-header-menu {
    min-width: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.widget-header-menu .handle {
    color: #BBB;
    font-size: 20px !important;
}
.widget-header-menu .el-cascader >>> * {
    display: none;
}
.toggle-title {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    border-radius: 0 0 0 60px;
}
.widget-content {
    position: relative;
    flex: 1;
    max-height: 100%;
}
.widget .content {
    padding-top: 45px;
}
.widget-header-title {
    flex: 1;
    margin: auto 0;
    margin-right: 10%;
}
.widget-header-title h2 {
    margin: 0;
    font-weight: bold;
    padding-left: 15px;
    color: $--color-blue-new;
}
</style>

<script>
import {api, GrantedCondition} from 'macarons'
import DraggableBox from '../data/components/DraggableBox.vue'
import StyleBox from './style-box/StyleBox.vue'

export default {
  components: {
    DraggableBox: DraggableBox,
    StyleBox: StyleBox
  },
  props: {
    widget: {
      type: Object,
      required: true
    },
    header: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: {
        mode: 'basic',
        basic: {},
        style: {},
        showTitle: true,
        headerStyle: {
          'background-color': 'rgba(255,255,255,1)'
        }
      },
      data: {
        description: null,
        date: null
      },
      refresh: false,
      widgetData: null,
      title: null,
      showMenu: false,
      showDescriptionBox: false,
      showStyleBox: false,
      showTitle: true,
      hideTitleTimeout: null,
      loading: true,
      menu: [],
      baseMenuLength: 0
    }
  },
  mounted () {
    if (!this.header) {
      const editCondition = new GrantedCondition('edit', 'AppBundle\\Entity\\Macarons\\Widget')
      editCondition.resolve().then(grant => {
        if (grant) {
          this.baseMenuLength = 1
          this.getWidgetMenu().children.splice(0, 0, {
            label: 'Modifier la Position',
            value: this.handlePosition
          })
        }
      })
      const deleteCondition = new GrantedCondition('edit', 'AppBundle\\Entity\\Macarons\\Widget')
      deleteCondition.resolve().then(grant => {
        if (grant) {
          this.getWidgetMenu().children.splice(1, 0, {
            label: 'Supprimer',
            value: this.handleDelete
          })
        }
      })
    }
    window.addEventListener('resize', this.resizeEvent)
    this.load()
    this.$refs.menu.$watch('menuVisible', val => {
      this.showMenu = val
    })
    this.$watch('options.showTitle', val => {
      this.showTitle = val
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEvent)
  },
  watch: {
    widget () {
      this.load()
    }
  },
  methods: {
    formatDate (date) {
      date = new Date(date)
      return `${date.getDate().toString().padStart(2, 0)}/${(date.getMonth() + 1).toString().padStart(2, 0)}/${date.getFullYear()}`
    },
    handleUpdateGraphData (data) {
      if (data.metadata && data.metadata.measures && data.metadata.measures.length) {
        this.data.date = data.metadata.measures.reduce((acc, measure) => {
          if (!measure.ReferenceDate) {
            return acc
          }
          if (!acc) {
            return measure.ReferenceDate
          }
          return measure.ReferenceDate > acc ? measure.ReferenceDate : acc
        }, null)
      } else {
        this.data.date = null
      }
    },
    resizeEvent () {
      this.$emit('resize')
    },
    getWidgetMenu () {
      const menu = this.menu.find(m => m.value === 'widget')
      if (menu) {
        return menu
      }
      const newMenu = {
        label: 'Widget',
        value: 'widget',
        children: [
          {
            label: 'Style',
            value: this.handleStyle
          },
          {
            label: 'Description',
            value: this.handleDescription
          }
        ]
      }
      this.menu.push(newMenu)
      return newMenu
    },
    load () {
      this.refresh = false
      this.$nextTick(() => {
        this.refresh = true
      })
      api.get('widget/' + this.widget.id + '/style').then(({data}) => {
        this.options.style = Array.isArray(data.style.style) ? {} : data.style.style
        this.options.headerStyle = Array.isArray(data.style.headerStyle) ? {} : data.style.headerStyle
        this.options.mode = data.style.mode || 'basic'
        this.options.basic = data.style.basic
        this.options.showTitle = data.style.showTitle || true
        this.data.description = data.description || null
        this.widgetData = data
      }).catch(() => {
      }).finally(() => {
        this.loading = false
      })
    },
    handleDescriptionCancel () {
      this.data.description = this.widgetData ? this.widgetData.description : null
      this.showDescriptionBox = false
    },
    handleDescriptionSave () {
      api.post('widget/' + this.widget.id + '/style-data', this.data).then(({data}) => {
        this.widgetData = data
        this.showDescriptionBox = false
      })
    },
    handleTitleChange (title) {
      this.title = title
    },
    handleMenuChange (menu) {
      if (Array.isArray(menu)) {
        this.menu.splice(0, this.menu.length - this.baseMenuLength, ...menu)
      }
    },
    handleClick () {
      if (this.showMenu) {
        this.$refs.menu.handleClickoutside()
      } else {
        this.$refs.menu.handleClick()
      }
    },
    handleDelete () {
      this.$emit('delete', this.widget)
    },
    handleStyle () {
      this.showStyleBox = true
    },
    handlePosition () {
      this.$emit('resize')
      this.widget.props.allowResize = !this.widget.props.allowResize
      this.widget.props.allowDrag = this.widget.props.allowResize
      this.menu[this.menu.length - 1].children[0].label = (
        this.widget.props.allowResize ? 'Fixer la Position' : 'Modifier la Position'
      )
    },
    handleDescription () {
      this.showDescriptionBox = true
    },
    selectMenuItem (value) {
      if (value.length && typeof value[value.length - 1] === 'function') {
        value[value.length - 1]()
      }
    },
    hideTitle () {
      if (!this.options.showTitle) {
        clearTimeout(this.hideTitleTimeout)
        this.hideTitleTimeout = setTimeout(() => {
          this.showTitle = false
        }, 500)
      }
    },
    preventTitleHide () {
      this.showTitle = true
      clearTimeout(this.hideTitleTimeout)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/Widget.vue